<template>
  <div
    v-loading.fullscreen.lock="fullscreenLoading"
    class="verify-box"
    style="width: 500px"
  >
    <el-dialog title="报销单支付" :visible="true" :before-close="onCloseDialog">
      <el-form>
        <el-form-item>
          <span style="font-size: 18px"
            >共{{ pay_num }}张,总计￥{{ pay_money }}</span
          >
        </el-form-item>
        <el-form-item label="出账银行:">
          <el-radio-group
            v-model="form.bank_select"
            @change="getBandAvailableBalance"
          >
            <el-radio label="boc">中国银行 </el-radio>
            <el-radio label="cmb">招商银行 </el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="账户余额:">
          <span>富米:￥{{ availableBalance.fumi_avabal }}</span>
          <span style="margin-left: 32px">
            一手:￥{{ availableBalance.yishou_avabal }}
          </span>
        </el-form-item>
        <el-form-item label="后台账号:">
          <span>{{ $cookie.get("username") }}</span>
        </el-form-item>
        <el-form-item label="后台密码:">
          <el-input
            v-model="form.password"
            type="password"
            placeholder="请输入密码"
            style="width: 80%"
          ></el-input>
        </el-form-item>
        <el-form-item label="验证码: ">
          <el-input
            v-model="phoneCode"
            class="el-dialog-col--small"
            placeholder="请输入手机验证码"
            style="width: 60%"
          ></el-input>
          <el-button
            type="primary"
            class="code-btn"
            :disabled="!show"
            style="margin-bottom: 10px"
            @click="sendsms()"
          >
            <span v-show="show">获取短信验证码</span>
            <span v-show="!show" class="count">{{ count }} s</span>
          </el-button>
        </el-form-item>
        <el-form-item label="用途:">
          <el-input
            v-model="form.furinfo"
            placeholder="请输入用途"
            style="width: 80%"
          ></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="onCloseDialog">取 消</el-button>
        <el-button type="primary" @click="do_pay()">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import md5 from "js-md5";
import { postGetBankAvabal } from "@/openapi/erp/supplySettleBill.js";

const TIME_COUNT = 60;
export default {
  props: {
    ids: {
      type: Array,
      default: 0,
    },
    url: {
      type: String,
      default: 0,
    },
    pay_num: {
      type: Number,
      default: 0,
    },
    pay_money: {
      type: Number,
      default: 0,
    },
    props_furinfo: {
      type: String,
      default: "代用户支付服装商家货款",
    },
  },
  data() {
    return {
      form: {
        password: "",
        furinfo: this.props_furinfo,
        bank_select: "cmb",
      },
      loading: false,
      shipping_num: "",
      show: true,
      count: "",
      timer: null,
      phoneCode: "",
      fullscreenLoading: false,
      availableBalance: {
        fumi_avabal: "0.00",
        yishou_avabal: "0.00",
      },
    };
  },
  created() {
    // 获取银行可用余额
    this.getBandAvailableBalance();
  },
  mounted() {
    this.filterData();
  },
  methods: {
    filterData() {
      if (this.pay_num == 0) {
        this.$message.error("请选择订单");
        this.onCloseDialog();
      }
    },
    do_pay() {
      if (this.pay_num == 0) {
        this.$message.error("请选择订单");
        this.onCloseDialog();
      } else {
        this.fullscreenLoading = true;
        this.$http
          .post(this.url, {
            operation_type: "pay",
            ykb_ids: this.ids,
            verify_code: this.phoneCode,
            expense_usage: this.form.furinfo,
            bank_select: this.form.bank_select,
          })
          .then((res) => {
            this.fullscreenLoading = false;
            if (res.data.code !== 200) {
              this.$message.error(res.data.msg);
            } else {
              this.$message.success(res.data.msg);
              this.onCloseDialog();
            }
          });
      }
    },
    sendsms() {
      const url = "/erp/Admin/sendSmsByPwd";
      const args = {
        name: this.$cookie.get("username"),
        password: md5(this.form.password),
        type: 2,
      };

      this.$http.post(url, args).then((res) => {
        if (res.data.code !== 200) {
          this.$message.error(res.data.msg);
        } else {
          this.$message.success(res.data.msg);
          this.timecount();
        }
      });
    },
    timecount() {
      if (!this.timer) {
        this.count = TIME_COUNT;
        this.show = false;
        this.timer = setInterval(() => {
          if (this.count > 0 && this.count <= TIME_COUNT) {
            this.count--;
          } else {
            this.show = true;
            clearInterval(this.timer);
            this.timer = null;
          }
        }, 1000);
      }
    },
    onCloseDialog() {
      this.$emit("onCloseDialog", false);
    },
    // 获取银行可用余额
    getBandAvailableBalance() {
      postGetBankAvabal({ bank_select: this.form.bank_select }).then((res) => {
        this.availableBalance = res;
      });
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/pages/ykbFlowdetail/PayOrderTem.vue